<script setup lang="ts">

import {computed, ref} from "vue";

interface Props {
    setupKey: string
}

const props = defineProps<Props>()

const isDialogOpen = ref(false)

const secret = computed(() => {
    return props.setupKey
        .split('?')[1]
        .split('&')[0]
        .split('=')[1]
})
</script>

<template>
    <v-dialog
        v-model="isDialogOpen"
        max-width="500"
        scrim="grey"
    >
        <template #activator="{ props: attrs }">
            <a
                class="text-primary text-decoration-underline cursor-pointer font-weight-medium"
                v-bind="attrs"
                v-text="'setup key'"
            />
        </template>

        <v-card
            :flat="true"
            rounded="lg"
            class="border"
        >
            <v-card-title class="font-weight-bold text-body-2 pb-0">
                Your two-factor secret
                <v-btn
                    variant="flat"
                    size="x-small"
                    icon="mdi-close"
                    class="float-end"
                    rounded="lg"
                    @click="isDialogOpen = false"
                />
            </v-card-title>

            <v-card-text class="text-grey-darken-2 pa-4">
                <code>{{ secret }}</code>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<style scoped>

</style>
